import { Plugin } from '../entities/plugin'

export const ResizeCanvasPlugin = Plugin.create({
  name: 'resize-canvas',
  onResize(event, graph) {
    graph.fitViewport()
  },
})
